import { toasterSlice } from './reducers'

export const { addToastAction, removeToastAction } = toasterSlice.actions
